export default "__VITE_ASSET__DQlhWXgu__"